import { render, staticRenderFns } from "./IgsusHighSchoolReport.vue?vue&type=template&id=22b7df90&"
import script from "./IgsusHighSchoolReport.vue?vue&type=script&lang=js&"
export * from "./IgsusHighSchoolReport.vue?vue&type=script&lang=js&"
import style0 from "./IgsusHighSchoolReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports